// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon[data-v-d7f37842]{padding:5px 13px 5px 13px}.logo[data-v-d7f37842]{height:50px;weight:50px}.mheader[data-v-d7f37842]{position:sticky;top:0;z-index:10;border-bottom:2px solid #e8e8e8;background-color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
